import {
  updatePaymentFormInitiated,
  updatePropertyData,
  updatePropertyRoom,
  updatePropertyTenancy,
} from "@App/userHistoryReducer";
import getActionInitiatedData from "@Components/LeadFormV2/utils/getActionInitiatedData";
import getPaymentFormLink from "@Pages/PropertyPage/components/PropertyCTAs/utils/getPaymentFormLink";
import { HAPPY_FLOW_TENANCY_CTAS } from "constants/index";
import { Dispatch } from "react";

const updateInitiatePayment = ({
  inventory,
  selectedInventory,
  dispatch,
  selectedRoom,
  selectedTenancy,
}: {
  inventory: any;
  selectedInventory: any;
  dispatch: Dispatch<any>;
  selectedRoom: any;
  selectedTenancy: any;
}) => {
  const isTenancy = Boolean(selectedTenancy);

  const link = getPaymentFormLink({
    rooms: inventory.active_children,
    canonicalName: inventory.canonical_name,
    id: selectedInventory.id,
  });
  const payment_initiated = getActionInitiatedData({
    inventory: selectedInventory,
    label: HAPPY_FLOW_TENANCY_CTAS.CONTINUE_PAYMENT,
    isTenancy,
  });
  dispatch(updatePropertyData({ inventoryId: inventory.id, payment_initiated }));

  dispatch(
    updatePaymentFormInitiated({
      inventoryId: inventory.id,
      id: selectedInventory.id,
      updatePaymentFormInitiatedData: {
        link,
        label: HAPPY_FLOW_TENANCY_CTAS.CONTINUE_PAYMENT,
        name: inventory.name,
        pricing: selectedInventory.pricing,
        config_images: selectedRoom?.images?.length ? selectedRoom?.images : inventory.images,
      },
    }),
  );

  if (isTenancy) {
    dispatch(
      updatePropertyTenancy({
        roomId: selectedRoom.id,
        tenancyId: selectedTenancy.id,
        label: HAPPY_FLOW_TENANCY_CTAS.CONTINUE_PAYMENT,
        payment_initiated: true,
        link,
      }),
    );
  } else {
    dispatch(
      updatePropertyRoom({
        roomId: selectedRoom.id,
        label: HAPPY_FLOW_TENANCY_CTAS.CONTINUE_PAYMENT,
        payment_initiated: true,
        link,
      }),
    );
  }
};

export default updateInitiatePayment;
